import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  FORCE_PASSWORD_CHANGE,
  SETTING_NEW_PASSWORD,
} from './actionTypes'

const initialState = {
  error: null,
  loading: false,
  user: null,
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case LOGOUT_USER:
      state = { ...state }
      break

    case FORCE_PASSWORD_CHANGE:
      state = {
        ...state,
        user: action.payload,
        loading: false,
        passwordChange: true,
      }
      break
    case SETTING_NEW_PASSWORD:
      state = {
        ...state,
        loading: true,
        passwordChange: false,
      }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
